export default __webpack_public_path__ + "static/media/image-header.b7cf98e2.png";